import { AlertCircle } from 'lucide-react';

/**
 * The one no-access state for settings an administrator manages. Shown in
 * place of the page rather than letting it render with controls the viewer
 * cannot use, a raw HTTP error, or silently empty values.
 */
export function AdministratorsOnly({ what }: { what: string }) {
  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-[14px] border border-[var(--co-line)] bg-[var(--co-raised)] p-6"
      style={{ boxShadow: 'var(--co-shadow-card)' }}
    >
      <AlertCircle className="mt-0.5 h-5 w-5 flex-none text-amber-500" aria-hidden />
      <div>
        <h1 className="text-base font-semibold text-[var(--co-ink)]">Administrators only</h1>
        <p className="mt-1 text-sm text-[var(--co-ink-3)]">
          Ask an administrator of your organization to {what}.
        </p>
      </div>
    </div>
  );
}

export default AdministratorsOnly;
